import { render, staticRenderFns } from "./faq_tianmi.vue?vue&type=template&id=c564b4aa&scoped=true&"
import script from "./faq_tianmi.vue?vue&type=script&lang=js&"
export * from "./faq_tianmi.vue?vue&type=script&lang=js&"
import style0 from "./faq_tianmi.vue?vue&type=style&index=0&id=c564b4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c564b4aa",
  null
  
)

export default component.exports